/**
 * Sponsor/supporter logos — shown on Home (flat) and Über uns (tiered).
 * `logo` is a path under public/assets/sponsoring/ — white/light-colored,
 * meant for the site's dark sections (Home's flat row, the Partner tier
 * wall). `logoLight` is an optional dark-colored variant for use on the
 * white Hauptförderer box on the Über-uns page (a white-on-white logo
 * would be invisible there); falls back to `logo` if not given. `tier`
 * is "hauptfoerderer" (main sponsor, shown larger in the white box) or
 * "partner" (material/service donor, shown in the dark logo wall) —
 * defaults to "partner" when unspecified, the more modest claim.
 *
 * `logoWidth` is the logo's own intrinsic width-at-44px-height (its native
 * aspect ratio scaled to the fixed 44px render height used across
 * SponsorLogos/SponsorShowcase) — passed through as the <img> width/height
 * attributes so the browser can reserve layout space before the image
 * loads, instead of causing a layout shift.
 */
export const SPONSORS = [
  {
    name: "UnlimitedPixel",
    url: "https://unlimitedpixel.de",
    logo: "/assets/sponsoring/logo.white.svg",
    logoLight: "/assets/sponsoring/logo.svg",
    logoWidth: 203,
    tier: "hauptfoerderer",
  },
  {
    name: "Epic Armoury",
    url: "https://epicarmoury.com",
    logo: "/assets/sponsoring/Marketing-Logos-EpicArmoury-White.png",
    logoWidth: 160,
    tier: "partner",
  },
];
